import type { ClubRole } from '@train2volley/shared';

export const ROLE_LABEL: Record<ClubRole, string> = {
  owner: 'Eigenaar',
  admin: 'Beheerder',
  member: 'Trainer',
};
